import { Box, Text } from '@factorialco/deprecated-design-system'
import { isEmpty } from 'lodash'

import { observer } from 'mobx-react'

import i18n from 'modules/core/lib/i18n'

import ArchivedBox from 'modules/locations/components/WorkAreas/ArchivedBox'
import UnarchiveWorkAreasItem from 'modules/locations/components/WorkAreas/UnarchivedItems'
import { WorkAreaNode } from 'modules/locations/hooks/useWorkAreas'

interface PropsWorkArea {
  locationId: string
  archivedWorkAreas: NonNullable<WorkAreaNode>[]
  unArchivedWorkAreas: NonNullable<WorkAreaNode>[]
  canManageWorkArea: boolean
  canAddSpace: boolean
}

const LocationWorkAreas = ({
  locationId,
  archivedWorkAreas,
  unArchivedWorkAreas,
  canManageWorkArea,
  canAddSpace,
}: PropsWorkArea) => {
  return (
    <>
      {!isEmpty(unArchivedWorkAreas) ? (
        <UnarchiveWorkAreasItem
          locationId={locationId}
          unarchiveWorkAreas={unArchivedWorkAreas}
          canManageWorkArea={canManageWorkArea}
          canAddSpace={canAddSpace}
        />
      ) : (
        <Box paddingBottom="s16">
          <Box
            width="full"
            paddingY="s32"
            paddingX="s32"
            border={{
              all: {
                color: 'grey400',
                width: 's1',
                style: 'solid',
              },
            }}
            borderRadius={{
              all: 'abs004',
            }}
            textAlign="center"
          >
            <Text size="300" weight="medium">
              {i18n.t('settings.locations.location.work_areas.empty_message')}
            </Text>
          </Box>
        </Box>
      )}

      {!isEmpty(archivedWorkAreas) && (
        <ArchivedBox locationId={locationId} archivedCount={archivedWorkAreas.length} />
      )}
    </>
  )
}

export default observer(LocationWorkAreas)
